import { render, staticRenderFns } from "./profile-card.vue?vue&type=template&id=1d46e56e&"
import script from "./profile-card.vue?vue&type=script&lang=js&"
export * from "./profile-card.vue?vue&type=script&lang=js&"
import style0 from "./profile-card.vue?vue&type=style&index=0&lang=stylus&scpoed=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports